module.exports = __webpack_public_path__ + "static/media/notification_right_img.1b17e180.svg";